import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`The Header and You`}</h1>
    <p>{`The Header is very straight forward. You can find it's component in `}<strong parentName="p">{`src/modules/navigation/Header.js`}</strong>{`.
It's currently built to accept 3 types of frontmatter variables:`}</p>
    <ol>
      <li parentName="ol">{`title`}</li>
      <li parentName="ol">{`header`}</li>
      <li parentName="ol">{`headerOrder`}</li>
    </ol>
    <p>{`You can find the data being pulled and ordered in from the Header component.`}</p>
    <h2>{`title (String)`}</h2>
    <p>{`Typical Title Rule shenanigans for label purposes. Learn more about it `}<a parentName="p" {...{
        "href": "/navigation#The-Title-Rule"
      }}>{`here`}</a></p>
    <pre><code parentName="pre" {...{}}>{`---
title: "Label that shows up on Sidenav, Header, and Breadcrumbs"
---
`}</code></pre>
    <h2>{`header (Boolean)`}</h2>
    <p>{`True/False boolean for whether this page should displayed in the header or not. `}</p>
    <pre><code parentName="pre" {...{}}>{`---
header: true
---
`}</code></pre>
    <h2>{`headerOrder (Integer or Float)`}</h2>
    <p>{`By default the Header is order ordered by a priority system:`}</p>
    <ol>
      <li parentName="ol">{`If headerOrder frontmatter exists it takes priority over other header nodes. `}</li>
      <li parentName="ol">{`The lower headerOrder is the sooner it will show up, you can use any numbers. (ie. 0 is First, 10 would be last, 0.1 would be Second)`}</li>
      <li parentName="ol">{`If the file has header set to true, but no header order then it is ordered by A-Z. `}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`---
header: true
headerOrder: 0
---
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      